export default __webpack_public_path__ + "static/media/nft-3@2x.6f25f0f2.png";